import type { WithId } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

import type {
  CommentReadsState,
  MarkReadPayload,
  ReadMarkPayload,
} from './types'

export const CommentReadsActions = {
  list: createAction<WithId>('COMMENT_READS_FETCH_LIST'),
  markRead: createAction<MarkReadPayload>('COMMENT_READS_MARK_SAGA'),
  markUnread: createAction<MarkReadPayload>('COMMENT_READS_UNREAD_SAGA'),
}

export const InternalCommentReadsActions = {
  set: createAction<CommentReadsState>('COMMENT_READS_SET'),
  update: createAction<ReadMarkPayload>('COMMENT_READS_UPDATE'),
}
